import { AuthService } from '@auth0/auth0-angular';
import { combineLatest, filter } from 'rxjs';
import { UserService } from './services';
import { environment } from '@/environments/environment';

export function initializeUserIdle(
  auth: AuthService,
  userService: UserService,
) {
  userService.initializeIdleTimeoutHandling();

  combineLatest([auth.isAuthenticated$, auth.isLoading$])
    .pipe(
      filter(([isAuthenticated, isLoading]) => isAuthenticated && !isLoading),
    )
    .subscribe(() => {
      userService.startWatchingForIdleTimeout();
    });
}

export async function initializeAgentLocatorScript(document: Document) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const scriptUrl =
      environment.agentLocatorScriptLocation?.toString() ??
      new URL(
        '/agents/locations/agent-locator.js',
        environment.servicesRoot,
      ).toString();
    script.src = scriptUrl;
    script.onload = resolve;
    script.onerror = reject;

    document.head.appendChild(script);
  });
}
